// UI/LoadingBar/LoadingBar.jsx
import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

export default function ProgressBar({
  progress = 0,
  label = "Loading...",
  showLoadingText = false,
}) {
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 0,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
      ...theme.applyStyles("dark", {
        backgroundColor: theme.palette.grey[800],
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 0,
      backgroundColor: "#ce2357",
      ...theme.applyStyles("dark", {
        backgroundColor: "#ce2357",
      }),
    },
  }));

  return (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      {showLoadingText && (
        <Typography
          variant="h5"
          sx={{ mb: 1 }}
          className="loading-percentage-text"
        >
          Loading {Math.round(progress)}%
        </Typography>
      )}
      <BorderLinearProgress
        variant="determinate"
        value={progress}
        hidden={10}
      />
    </Box>
  );
}
